import { Tab } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";

import useStyles from "../../../../styles/styles";
// import { Card, CardActionArea, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import { TabContext, TabList } from "@mui/lab";

const tabNames = [
  "user",
  "info",
  "appointments",
  "tests",
  "diagnoses",
  "treatments",
  "observations",
  "archives",
  "bills",
  "receipts",
  "balance",
];

const Patient = () => {
  const classes = useStyles();

  const [chosenInfo, setChosenInfo] = useState<any>(tabNames.indexOf("user"));

  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    tabNames.map((name) => {
      if (pathname.includes(name)) setChosenInfo(tabNames.indexOf(name));
    });
  }, [pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setChosenInfo(tabNames.indexOf(newValue));
  };

  const renderTabs = () => {
    return tabNames.map((name, index) => (
      <Link to={name} style={{ textDecoration: "none"}} key={index+name}>
        <Tab
          key={index + name}
          sx={{ mr: 4, width:"100%" }}
          label={name.charAt(0).toUpperCase() + name.slice(1)}
          value={name}
          className={chosenInfo === tabNames.indexOf(name) ? classes.pressedTab : classes.unPressedTab}
        />
      </Link>
    ));
  };

  return (
    <>
      {/* <Box sx={{ width: "100%", mb: 3 }}>
        <Box sx={{ bgcolor: "#fff", p: 4 }}>
          <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center">
            <Grid item xs={6} md={1.5}>
              <Link to="user" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "user" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("user");
                    }}
                  >
                    <CardContent>
                      <Typography>User Info</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={6} md={1.5}>
              <Link to="info" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "info" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("info");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Info</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={6} md={2}>
              <Link to="appointments" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "appointments" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("appointments");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Appointments</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={6} md={1.7}>
              <Link to="tests" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "tests" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("tests");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Tests</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={6} md={1.9}>
              <Link to="diagnoses" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "diagnoses" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("diagnoses");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Diagnoses</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={6} md={1.7}>
              <Link to="treatments" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "treatments" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("treatments");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Treatments</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={6} md={2}>
              <Link to="observations" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "observations" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("observations");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Observations</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>

            <Grid item xs={6} md={1.8}>
              <Link to="archives" style={{ textDecoration: "none" }}>
                <Card>
                  <CardActionArea
                    href=""
                    style={{ display: "flex", justifyContent: "center" }}
                    className={chosenInfo === "archives" ? classes.pressedButton : classes.unPressedButton}
                    onClick={() => {
                      setChosenInfo("archives");
                    }}
                  >
                    <CardContent>
                      <Typography>Patient Archives</Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
            <Grid item xs={4} md={1.8}>
                <Link to="bills" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "bills" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("bills");
                      }}
                    >
                      <CardContent>
                        <Typography>Patient Bills</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.8}>
                <Link to="receipts" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "receipts" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("receipts");
                      }}
                    >
                      <CardContent>
                        <Typography>Patient Receipts</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
              <Grid item xs={4} md={1.8}>
                <Link to="balance" style={{ textDecoration: "none" }}>
                  <Card>
                    <CardActionArea
                      href=""
                      style={{ display: "flex", justifyContent: "center" }}
                      className={chosenInfo === "balance" ? classes.pressedButton : classes.unPressedButton}
                      onClick={() => {
                        setChosenInfo("balance");
                      }}
                    >
                      <CardContent>
                        <Typography>Patient Balance</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
          </Grid>
        </Box>
      </Box> */}
      <Box sx={{ width: "100%", typography: "body1", mb: 3 }}>
        <Box sx={{ bgcolor: "#fff", p: 4 }}>
          <TabContext value={chosenInfo}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label=""
                variant="scrollable"
                visibleScrollbar={false}
                indicatorColor="secondary"
                sx={{ ml:-1, justifyContent: "space-between", justifyItems: "center" }}
              >
                {renderTabs()}
              </TabList>
            </Box>
          </TabContext>
        </Box>
      </Box>
      <Outlet />
    </>
  );
};

export default Patient;
